import styled, {css} from 'styled-components';

interface ItemProps {
  readonly empty?: boolean;
}

export const ConfigWrapper = styled.section`
  background-color: var(--BackgroundGrey);
  padding-top: 20px;
  height: 90vh;
  display: flex;
`;

export const ConfigCard = styled.div`
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.02);
  background-color: var(--BackgroundColor);
  border: 1px solid var(--LightGray);
  border-radius: 8px;
  margin: 35px;
  width: fit-content;
`;

export const ConfigCardLeft = styled.div`
  border-right: 1px solid var(--LightGray);
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: flex;
`;

export const CLeftBadges = styled.div`
  margin-top: 30px;
`;

export const CLeftInputs = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 30px;
`;

export const CLeftInputSection = styled.div`
  max-width: 70px;

  &:last-of-type {
    max-width: 70px;
    margin-left: 20px;
  }
`;

export const CLeftActions = styled.div<ItemProps>`
  justify-content: center;
  flex-direction: column;
  align-items: center;
  min-width: 350px;
  padding: 30px 0px;
  display: flex;

  ${props => {
    const empty = props.empty ? `border-top: 1px solid var(--LightGray);` : 'none';

    return css`
        ${empty}
    `;
  }};
`;

export const CLeftActionInfo = styled.span`
  text-align: center;
  margin-top: 10px;
  max-width: 202px;
  font-size: 11px;
  color: #9b9b9b;
`;

export const ConfigCardRight = styled.div``;

export const CRightTop = styled.div`
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
  grid-gap: 10px 33px;
  padding: 40px;
  display: grid;
  @media (max-width: 1215px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const CRightInputWrapper = styled.div`
  display: flex;
`;

export const CRightPasswordWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

export const CRightBottom = styled.div`
  border-top: 1px solid var(--LightGray);
  flex-grow: 7;
  padding: 35px 45px 45px 0px;
  justify-content: flex-end;
  display: flex;
`;
export const InputWrapper = styled.div`
  position: relative;
`;
export const TopWrapper = styled.div`
  background-color: var(--BackgroundColor);
  border-radius: 8px 8px;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  min-width: 1215px;
  @media (max-width: 1215px) {
    min-width: unset;
  }
  @media (max-width: 1050px) {
    display: block;
  }
`;
export const BottomWrapper = styled.div``;
